export default "__VITE_ASSET__BEw$c_bi__"